module.exports = __webpack_public_path__ + "static/media/logo.d4b4f74c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 240
// module chunks = 0